/**
 * Reviews Service
 * Handles customer review operations
 */

const BASE_URL = process.env.NODE_ENV === 'production'
  ? (process.env.REACT_APP_API_URL || '/api')
  : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api');

export const getTopReviews = async (limit = 5) => {
  const safeLimit = Math.max(1, Math.min(Number(limit) || 5, 20));
  const response = await fetch(`${BASE_URL}/reviews/top?limit=${safeLimit}`);

  if (!response.ok) {
    throw new Error(`Failed to fetch reviews: ${response.status}`);
  }

  return response.json();
};

export const createReview = async (reviewData) => {
  const response = await fetch(`${BASE_URL}/reviews`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(reviewData),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to submit review');
  }

  return response.json();
};

const reviewServiceExports = {
  getTopReviews,
  createReview,
};

export default reviewServiceExports;
